export default __webpack_public_path__ + "static/media/icon-check-stake.edb693de.svg";